import BaseService from "./base.service";
import $store from "../store";
import OrdersService from "./orders.service";

class UsersService extends BaseService {
  get entity() {
    return "users";
  }

  async getCurrentUser() {
    return new Promise((resolve, reject) => {
      return this.request({ auth: true })
        .get(`${this.entity}/profile`)
        .then((response) =>
          resolve(this.responseWrapper(response, response.data.data)),
        )
        .catch((error) => {
          const message = error.response.data
            ? error.response.data.error
            : error.response.statusText;
          reject(this.errorWrapper(error, message));
        });
    });
  }

  updateProfile(data) {
    return new Promise((resolve, reject) => {
      return this.request({ auth: true })
        .post(`${this.entity}/profile`, data)
        .then((response) => {
          $store.dispatch("fetchUser");
          resolve(this.responseWrapper(response, response.data.data));
        })
        .catch((error) => {
          const message = error.response.data
            ? error.response.data.error
            : error.response.statusText;
          reject(this.errorWrapper(error, message));
        });
    });
  }

  generateOneSignalTags() {
    return new Promise((resolve, reject) => {
      return this.request({ auth: true })
        .get(`${this.entity}/profile/oneSignalTags`)
        .then((response) => {
          resolve(this.responseWrapper(response, response.data.data));
        })
        .catch((error) => {
          const message = error.response.data
            ? error.response.data.error
            : error.response.statusText;
          reject(this.errorWrapper(error, message));
        });
    });
  }

  deleteCard(data) {
    return new Promise((resolve, reject) => {
      return this.request({ auth: true })
        .delete(`${this.entity}/credit_card`, { data })
        .then((response) =>
          resolve(this.responseWrapper(response, response.data.data)),
        )
        .catch((error) => {
          const message = error.response.data
            ? error.response.data.error
            : error.response.data.message;
          console.log(error.response);
          reject(this.errorWrapper(error, message));
        });
    });
  }

  getCards() {
    return new Promise((resolve, reject) => {
      return this.request({ auth: true })
        .get(`${this.entity}/credit_card`)
        .then((response) =>
          resolve(this.responseWrapper(response, response.data.data)),
        )
        .catch((error) => {
          const message = error.response.data
            ? error.response.data.error
            : error.response.data.message;
          console.log(error.response);
          reject(this.errorWrapper(error, message));
        });
    });
  }

  getFinancialStatement() {
    return new Promise((resolve, reject) => {
      return this.request({ auth: true })
        .get("me/financial-statement")
        .then((response) =>
          resolve(this.responseWrapper(response, response.data.data)),
        )
        .catch((error) => {
          const message = error.response.data
            ? error.response.data.error
            : error.response.data.message;
          console.log(error.response);
          reject(this.errorWrapper(error, message));
        });
    });
  }

  issueReceipt(chargeId) {
    return new Promise((resolve, reject) => {
      return this.request({ auth: true })
        .get(`me/financial-statement/receipt/generate?charge_id=${chargeId}`, {
          responseType: "blob",
        })
        .then((response) => {
          resolve(this.responseWrapper(response, response.data));
        })
        .catch((error) => {
          return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = function () {
              const errorResponse = JSON.parse(reader.result);
              resolve(errorResponse.message);
            };
            reader.onerror = function () {
              reject("Erro ao ler os dados");
            };
            reader.readAsText(error.response.data);
          })
            .then((message) => {
              reject(this.errorWrapper(error, message));
            })
            .catch((err) => {
              console.error(err);
            });
        });
    });
  }

  async addCard(cardData, captchaToken) {
    const cardHash = await OrdersService.createCardHash(cardData);
    const data = {
      card_hash: cardHash,
      captcha_token: captchaToken,
    };

    return new Promise((resolve, reject) => {
      return this.request({ auth: true })
        .post(`${this.entity}/credit_card`, data)
        .then((response) =>
          resolve(this.responseWrapper(response, response.data.data)),
        )
        .catch((error) => {
          const message = error.response.data
            ? error.response.data.error
            : error.response.data.message;
          console.log(error.response);
          reject(this.errorWrapper(error, message));
        });
    });
  }

  updateAvatar(file) {
    return new Promise((resolve, reject) => {
      const data = new FormData();
      data.append("file", file);
      return this.request({ auth: true })
        .post(`${this.entity}/profile/storeAvatar`, data)
        .then((response) => {
          $store.dispatch("fetchUser");
          resolve(this.responseWrapper(response, response.data.data));
        })
        .catch((error) => {
          const message = error.response.data
            ? error.response.data.error
            : error.response.statusText;
          reject(this.errorWrapper(error, message));
        });
    });
  }

  registerUser(data) {
    return new Promise((resolve, reject) => {
      return this.request({ auth: false })
        .post(`${this.entity}`, data)
        .then((response) =>
          resolve(this.responseWrapper(response, response.data.data)),
        )
        .catch((error) => {
          const message = error.response.data
            ? error.response.data.error
            : error.response.data.message;
          console.log(error.response);
          reject(this.errorWrapper(error, message));
        });
    });
  }

  getUserLeaningGuides(courseId, preparationStageId) {
    return new Promise((resolve, reject) => {
      return this.request({ auth: true })
        .get(
          `me/learning-guides?course_id=${courseId}&preparation_stage_id=${preparationStageId}`,
        )
        .then((response) => {
          const data = response.data.data;
          resolve(this.responseWrapper(response, data));
        })
        .catch((error) => {
          const message = error.response.data
            ? error.response.data.error
            : error.response.statusText;
          reject(this.errorWrapper(error, message));
        });
    });
  }
}

export default new UsersService();
